/* Colección fácil (v8): galería, vista rápida, filtros, "Ver más" sin recargar, completa tu envío gratis, vistos y volver al mismo lugar. */
(() => {
  if (window.gmColeccion) return;
  window.gmColeccion = true;

  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ROUTES = window.Shopify?.routes?.root || '/';
  const RECENT_KEY = 'gm-recent';
  const POS_KEY = 'gm-pos';
  let io;

  function reveal(scope = document) {
    const els = scope.querySelectorAll('[data-gm-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || root.classList.contains('shopify-design-mode') || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    io ||= new IntersectionObserver(
      (entries) => {
        entries
          .filter((e) => e.isIntersecting)
          .forEach((e, i) => {
            e.target.style.setProperty('--gm-d', `${Math.min(i * 70, 420)}ms`);
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
  }

  function money(cents, format) {
    const n = cents / 100;
    const num = (dec, thousands, decimal) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (d ? decimal + d : '');
    };
    const values = {
      amount: () => num(2, ',', '.'),
      amount_no_decimals: () => num(0, ',', '.'),
      amount_with_comma_separator: () => num(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => num(0, '.', ','),
      amount_with_space_separator: () => num(2, ' ', ','),
      amount_with_apostrophe_separator: () => num(2, "'", '.'),
    };
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (values[k] || values.amount)());
  }

  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const isNumber = (v) => /^\d+$/.test(v);
  const optName = (o) => (typeof o === 'string' ? o : o?.name || '');
  const shortSize = (s) => (/\(([^)]+)\)/.exec(s) || [, s])[1].trim();
  const sized = (src, w) => {
    if (!src) return '';
    const u = new URL(src.startsWith('//') ? `https:${src}` : src, location.href);
    u.searchParams.set('width', w);
    return u.toString();
  };
  const readJSON = (store, key, fallback) => {
    try {
      return JSON.parse(store.getItem(key)) ?? fallback;
    } catch (e) {
      return fallback;
    }
  };
  const writeJSON = (store, key, value) => {
    try {
      store.setItem(key, JSON.stringify(value));
    } catch (e) {}
  };
  const ICON = {
    left: '<svg class="gm-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>',
    right: '<svg class="gm-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>',
    star: '<svg class="gm-i" viewBox="0 0 24 24" aria-hidden="true"><path class="gm-fill" d="m12 3 2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 16.8l-5.4 2.9 1.1-6.1-4.5-4.2 6.1-.8Z"/></svg>',
  };

  /* Puntitos de la galería: se mueven solos al deslizar. */
  function bindTracks(scope) {
    scope.querySelectorAll('[data-gm-track]:not([data-bound])').forEach((track) => {
      track.dataset.bound = '1';
      const dots = track.parentElement.querySelectorAll('.gmc__gdots i');
      if (!dots.length) return;
      track.addEventListener(
        'scroll',
        () => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
        },
        { passive: true }
      );
    });
  }

  class GmColeccion extends HTMLElement {
    connectedCallback() {
      this.d = this.dataset;
      this.pages = 1;
      this.products = new Map();
      this.sizeNames = (this.d.sizeNames || '').toLowerCase().split(',').map((s) => s.trim()).filter(Boolean);
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-gm-sort]')) this.go({ sort_by: e.target.value });
      });
      this.onPop = () => this.render(new URL(location.href), 'none');
      window.addEventListener('popstate', this.onPop);
      this.onLeave = () => this.savePosition();
      window.addEventListener('pagehide', this.onLeave);
      bindTracks(this);
      this.watchMore();
      this.renderRecent();
      this.restorePosition();
      this.initSales();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPop);
      window.removeEventListener('pagehide', this.onLeave);
      clearTimeout(this.saleTimer);
    }

    onClick(e) {
      if (e.target.matches('dialog')) return e.target.close();
      const t = e.target.closest('button, a');
      if (!t || !this.contains(t) || t.disabled) return;
      const d = t.dataset;
      if ('gmSlide' in d) return this.slide(t, Number(d.gmSlide));
      if ('gmQv' in d) {
        e.preventDefault();
        return this.openQv(t.closest('[data-gm-card]')?.dataset.handle, t.closest('[data-gm-card]'));
      }
      if ('gmQvHandle' in d) return this.openQv(d.gmQvHandle);
      if ('gmPopClose' in d) return this.closeSale();
      if ('gmQvColor' in d) return this.qvSet({ color: d.gmQvColor });
      if ('gmQvSize' in d) return this.qvSet({ size: d.gmQvSize });
      if ('gmQvAdd' in d) return this.qvAdd(t);
      if ('gmVariant' in d) return this.addVariant(Number(d.gmVariant), t, Number(d.gmProduct));
      if ('gmLink' in d) return this.rememberCard(t.closest('[data-gm-card]'));
      if ('gmSize' in d) return this.toggleSize(d.gmSize);
      if ('gmType' in d) return this.go({ [this.d.typeParam]: d.gmType || null });
      if ('gmFilter' in d) return this.toggleParam(d.gmFilter, d.value);
      if ('gmPrice' in d) return this.applyPrice();
      if ('gmPriceClear' in d) return this.go({ [d.min]: null, [d.max]: null });
      if ('gmClearFilters' in d) return this.clearFilters();
      if ('gmFiltersOpen' in d) return this.querySelector('[data-gm-fdlg]')?.showModal();
      if ('gmAdd' in d) return this.add(t);
      if ('gmColor' in d) return this.color(t);
      if ('gmGuideOpen' in d) return this.querySelector('[data-gm-guide]')?.showModal();
      if ('gmClose' in d) return t.closest('dialog')?.close();
      if ('gmPick' in d) return this.pick(d.gmPick, t);
      if ('gmNext' in d) return this.more(t);
      if ('gmCart' in d) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.open) {
          e.preventDefault();
          drawer.open();
        }
        return;
      }
      if ('gmKeep' in d) {
        const sizes = this.sizes();
        if (!sizes.length) return;
        e.preventDefault();
        const url = new URL(t.href, location.href);
        sizes.forEach((s) => url.searchParams.append(this.d.sizeParam, s));
        location.href = url.toString();
      }
    }

    /* ---------- Galería ---------- */
    slide(btn, dir) {
      const track = btn.closest('.gmc__media, .gmc__qv-media')?.querySelector('[data-gm-track]');
      track?.scrollBy({ left: dir * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    /* ---------- "Ver más" ---------- */
    watchMore() {
      const btn = this.querySelector('[data-gm-next]');
      if (!btn) return;
      btn.addEventListener('pointerenter', () => this.prefetch(btn), { once: true });
      if (!('IntersectionObserver' in window)) return;
      this.moreObserver?.disconnect();
      this.moreObserver = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.prefetch(btn);
            this.moreObserver.disconnect();
          }
        },
        { rootMargin: '800px 0px' }
      );
      this.moreObserver.observe(btn);
    }

    pageUrl(page) {
      /* Parte de la URL actual para conservar ?view=facil, filtros y orden; solo cambia la página. */
      const url = new URL(location.href);
      url.searchParams.set('page', page);
      return url;
    }

    prefetch(btn) {
      if (!btn.gmPage) {
        btn.gmPage = this.load(this.pageUrl(btn.dataset.page));
        btn.gmPage.catch(() => (btn.gmPage = null));
      }
      return btn.gmPage;
    }

    /* Trae esta sección para una URL: primero solo la sección (rápido); si Shopify no la entrega, la página completa. */
    async load(url) {
      /* La URL va como texto: apps de la tienda (BOGOS, Sezerium) envuelven fetch y fallan con objetos URL. */
      const get = async (u) => {
        const res = await fetch(u.toString(), { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const found = doc.getElementById(this.id) || doc.querySelector('gm-coleccion');
        if (!found?.querySelector('[data-gm-results]')) throw new Error('sección no encontrada');
        return found;
      };
      const fast = new URL(url);
      fast.searchParams.set('section_id', this.d.section);
      try {
        return await get(fast);
      } catch (e1) {
        console.warn('[gm-coleccion] sección sola falló, uso la página completa:', e1.message, fast.toString());
        const full = new URL(url);
        full.searchParams.delete('section_id');
        try {
          return await get(full);
        } catch (e2) {
          throw new Error(`sección: ${e1.message} · página: ${e2.message} · ${full.pathname}${full.search}`);
        }
      }
    }

    append(doc) {
      const items = doc.querySelectorAll('[data-gm-grid] > .gmc__item');
      if (!items.length) throw new Error('sin prendas');
      const grid = this.querySelector('[data-gm-grid]');
      grid?.append(...items);
      const next = doc.querySelector('[data-gm-more]');
      if (next) this.querySelector('[data-gm-more]')?.replaceWith(next);
      this.pages += 1;
      bindTracks(this);
      reveal(this);
      this.watchMore();
    }

    /* Agrega las prendas de la siguiente página debajo de las actuales, sin recargar. */
    async more(btn) {
      const label = btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = this.d.loading;
      try {
        this.append(await this.prefetch(btn));
      } catch (e) {
        console.error('[gm-coleccion] no se pudo cargar "Ver más":', e);
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        this.fail(`${this.d.errMore} (${e.message})`, 15000);
      }
    }

    /* ---------- Volver al mismo lugar ---------- */
    savePosition() {
      writeJSON(sessionStorage, POS_KEY, { u: location.pathname + location.search, p: this.pages, y: Math.round(window.scrollY) });
    }

    async restorePosition() {
      const saved = readJSON(sessionStorage, POS_KEY, null);
      const nav = (performance.getEntriesByType?.('navigation') || [])[0];
      if (!saved || nav?.type !== 'back_forward' || saved.u !== location.pathname + location.search) return;
      sessionStorage.removeItem(POS_KEY);
      if (saved.p > 1) {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        try {
          for (let page = 2; page <= saved.p; page += 1) this.append(await this.load(this.pageUrl(page)));
        } catch (e) {
          console.warn('[gm-coleccion] no se pudo restaurar la lista:', e.message);
        }
      }
      this.querySelectorAll('[data-gm-reveal]').forEach((el) => el.classList.add('is-in'));
      window.scrollTo(0, saved.y);
    }

    /* ---------- Filtros ---------- */
    sizes(url = new URL(location.href)) {
      return this.d.sizeParam ? url.searchParams.getAll(this.d.sizeParam) : [];
    }

    /* Una talla de letras + una de cintura a la vez: Shopify las combina (M o 32). */
    toggleSize(value) {
      let current = this.sizes();
      if (current.includes(value)) current = current.filter((s) => s !== value);
      else current = current.filter((s) => isNumber(s) !== isNumber(value)).concat(value);
      this.go({ [this.d.sizeParam]: current });
    }

    toggleParam(param, value) {
      const current = new URL(location.href).searchParams.getAll(param);
      const next = current.includes(value) ? current.filter((v) => v !== value) : current.concat(value);
      this.go({ [param]: next });
    }

    applyPrice() {
      const min = this.querySelector('[data-gm-min]');
      const max = this.querySelector('[data-gm-max]');
      if (!min || !max) return;
      this.go({ [min.dataset.gmMin]: min.value || null, [max.dataset.gmMax]: max.value || null });
    }

    clearFilters() {
      const url = new URL(location.href);
      [...url.searchParams.keys()]
        .filter((k) => k.startsWith('filter.') && k !== this.d.sizeParam && k !== this.d.typeParam)
        .forEach((k) => url.searchParams.delete(k));
      url.searchParams.delete('page');
      this.render(url);
    }

    pick(label, btn) {
      btn.closest('dialog')?.close();
      const target = [...this.querySelectorAll('.gmc__sbtn')].find((b) => b.textContent.trim() === label);
      if (target && !target.disabled && target.getAttribute('aria-pressed') !== 'true') this.toggleSize(target.dataset.gmSize);
    }

    go(changes, mode = 'push') {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      Object.entries(changes).forEach(([key, value]) => {
        if (!key) return;
        url.searchParams.delete(key);
        [].concat(value ?? []).filter(Boolean).forEach((v) => url.searchParams.append(key, v));
      });
      this.render(url, mode);
    }

    async render(url, mode = 'push') {
      this.setAttribute('aria-busy', 'true');
      try {
        const doc = await this.load(url);
        const fresh = doc.querySelector('[data-gm-results]');
        const box = this.querySelector('[data-gm-results]');
        if (!fresh || !box) throw new Error('section');
        const scrollX = box.querySelector('[data-gm-cats]')?.scrollLeft || 0;
        fresh.querySelectorAll('[data-gm-reveal]:not(.gmc__item)').forEach((el) => el.classList.add('is-in'));
        box.replaceChildren(...fresh.childNodes);
        box.querySelector('[data-gm-cats]')?.scrollTo({ left: scrollX });
        const fbody = doc.querySelector('[data-gm-fbody]');
        if (fbody) this.querySelector('[data-gm-fbody]')?.replaceChildren(...fbody.childNodes);
        if (mode === 'push') history.pushState({}, '', url.pathname + url.search);
        if (mode === 'replace') history.replaceState({}, '', url.pathname + url.search);
        this.pages = 1;
        bindTracks(box);
        reveal(box);
        this.watchMore();
        if (!this.querySelector('[data-gm-fdlg]')?.open) this.toGrid();
      } catch (e) {
        console.error('[gm-coleccion] no se pudo actualizar la lista:', e);
        this.fail(`${this.d.errMore} (${e.message})`, 15000);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    toGrid() {
      const grid = this.querySelector('[data-gm-grid]');
      const bar = this.querySelector('.gmc__bar');
      if (!grid || !bar) return;
      const top = grid.getBoundingClientRect().top + window.scrollY - bar.offsetHeight - (parseInt(getComputedStyle(bar).top, 10) || 0) - 8;
      if (top < window.scrollY) window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
    }

    color(btn) {
      const card = btn.closest('[data-gm-card]');
      card.dataset.color = btn.dataset.gmColor;
      card.querySelectorAll('[data-gm-color]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      const img = card.querySelector('.gmc__img');
      if (img && btn.dataset.src) {
        img.srcset = btn.dataset.srcset;
        img.src = btn.dataset.src;
        card.querySelector('[data-gm-track]')?.scrollTo({ left: 0 });
      }
    }

    fail(message, ms = 4000) {
      const box = this.querySelector('[data-gm-err]');
      if (!box) return;
      box.textContent = message || this.d.errGeneric;
      box.hidden = false;
      clearTimeout(this.errTimer);
      this.errTimer = setTimeout(() => (box.hidden = true), ms);
    }

    /* ---------- Vista rápida ---------- */
    async product(handle) {
      if (!this.products.has(handle)) {
        const p = fetch(`${ROUTES}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
          r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))
        );
        this.products.set(handle, p);
        p.catch(() => this.products.delete(handle));
      }
      return this.products.get(handle);
    }

    async openQv(handle, card) {
      if (!handle) return;
      const dlg = this.querySelector('[data-gm-qvdlg]');
      const body = dlg?.querySelector('[data-gm-qvbody]');
      if (!dlg || !body) return;
      body.innerHTML = `<p class="gmc__fine">${esc(this.d.loading)}</p>`;
      if (!dlg.open) dlg.showModal();
      try {
        const p = await this.product(handle);
        const opts = p.options.map((o) => optName(o).toLowerCase().trim());
        const sizeIdx = opts.findIndex((o) => this.sizeNames.includes(o));
        const colorIdx = opts.findIndex((o) => ['color', 'colour', 'colores'].includes(o));
        const swatches = {};
        card?.querySelectorAll('[data-gm-color]').forEach((b) => (swatches[b.dataset.gmColor] = b.style.getPropertyValue('--c')));
        const active = this.sizes();
        const sizeVals = sizeIdx < 0 ? [] : [...new Set(p.variants.map((v) => v.options[sizeIdx]))];
        this.qv = {
          p,
          sizeIdx,
          colorIdx,
          swatches,
          stock: card ? new Map(JSON.parse(card.querySelector('[data-gm-variants]').textContent).map((v) => [v.id, v.q])) : null,
          rating: card?.dataset.rating,
          count: card?.dataset.count,
          color: colorIdx < 0 ? null : card?.dataset.color || (p.variants.find((v) => v.available) || p.variants[0]).options[colorIdx],
          size: sizeVals.find((s) => active.includes(s)) || null,
        };
        this.renderQv();
        this.remember({ h: p.handle, t: p.title, p: p.price, img: p.featured_image });
      } catch (e) {
        console.error('[gm-coleccion] vista rápida:', e);
        body.innerHTML = `<p class="gmc__fine">${esc(this.d.errGeneric)}</p>`;
      }
    }

    qvSet(change) {
      if (!this.qv) return;
      Object.assign(this.qv, change);
      this.renderQv(change.color != null);
    }

    qvVariant() {
      const { p, sizeIdx, colorIdx, color, size } = this.qv;
      const fits = (v) => (sizeIdx < 0 || v.options[sizeIdx] === size) && (colorIdx < 0 || v.options[colorIdx] === color);
      return p.variants.find((v) => fits(v) && v.available) || null;
    }

    renderQv(scrollToColor = false) {
      const { p, sizeIdx, colorIdx, swatches, rating, count, color, size } = this.qv;
      const body = this.querySelector('[data-gm-qvbody]');
      const fmt = this.d.moneyFormat;
      const images = (p.images || []).slice(0, 6);
      const variant = this.qvVariant();
      const price = variant?.price ?? p.price;
      const compare = variant?.compare_at_price ?? p.compare_at_price;
      const sale = compare > price;
      const colors = colorIdx < 0 ? [] : [...new Set(p.variants.map((v) => v.options[colorIdx]))];
      const sizes = sizeIdx < 0 ? [] : [...new Set(p.variants.map((v) => v.options[sizeIdx]))];
      const sizeOk = (s) => p.variants.some((v) => v.available && v.options[sizeIdx] === s && (colorIdx < 0 || v.options[colorIdx] === color));
      const needsSize = sizeIdx >= 0 && !size;
      const label = needsSize ? 'Elige tu talla' : size ? esc(this.d.addSize).replace('[talla]', esc(shortSize(size))) : esc(this.d.addLabel);
      const help = this.d.helpUrl;
      const note = this.stockNote();

      body.innerHTML = `
        <div class="gmc__qv-media">
          <div class="gmc__track" data-gm-track>
            ${images.map((src) => `<div class="gmc__slide"><img class="gmc__img" src="${esc(sized(src, 900))}" srcset="${esc(sized(src, 500))} 500w, ${esc(sized(src, 900))} 900w, ${esc(sized(src, 1300))} 1300w" sizes="(min-width: 750px) 440px, 100vw" alt="${esc(p.title)}" loading="lazy"></div>`).join('')}
          </div>
          ${images.length > 1 ? `<div class="gmc__gdots" aria-hidden="true">${images.map((_, i) => `<i${i ? '' : ' class="is-on"'}></i>`).join('')}</div>
          <button type="button" class="gmc__nav gmc__nav--prev" data-gm-slide="-1" aria-label="Foto anterior">${ICON.left}</button>
          <button type="button" class="gmc__nav gmc__nav--next" data-gm-slide="1" aria-label="Foto siguiente">${ICON.right}</button>` : ''}
        </div>
        <div class="gmc__qv-info">
          ${p.vendor ? `<p class="gmc__vendor">${esc(p.vendor)}</p>` : ''}
          <h3 class="gmc__qv-title">${esc(p.title)}</h3>
          ${rating ? `<p class="gmc__rate">${ICON.star}<b>${esc(rating)}</b>(${esc(count)})</p>` : ''}
          <p class="gmc__price${sale ? ' is-sale' : ''}"><b>${esc(money(price, fmt))}</b>${sale ? `<s>${esc(money(compare, fmt))}</s>` : ''}</p>
          ${note ? `<p class="gmc__stock"><i></i>${esc(note)}</p>` : ''}
          ${colors.length > 1 ? `<div class="gmc__qv-row"><p class="gmc__grp-t">${esc(optName(p.options[colorIdx]) || 'Color')}: <span>${esc(color)}</span></p>
            <div class="gmc__dots">${colors.map((c) => `<button type="button" class="gmc__dot" data-gm-qv-color="${esc(c)}" style="--c: ${esc(swatches[c] || '#c9ccc8')}" aria-label="${esc(c)}" aria-pressed="${c === color}"></button>`).join('')}</div></div>` : ''}
          ${sizes.length ? `<div class="gmc__qv-row"><p class="gmc__grp-t">${esc(optName(p.options[sizeIdx]) || 'Talla')}</p>
            <div class="gmc__pick">${sizes.map((s) => `<button type="button" data-gm-qv-size="${esc(s)}" aria-pressed="${s === size}" ${sizeOk(s) ? '' : 'disabled'}>${esc(shortSize(s))}</button>`).join('')}</div></div>` : ''}
          <button type="button" class="gm-btn gmc__qv-add" data-gm-qv-add ${variant ? '' : 'disabled'}>${variant || needsSize ? label : esc(this.d.errSoldout)}</button>
          <p class="gmc__qv-links"><a href="${esc(p.url || `${ROUTES}products/${p.handle}`)}">Ver ficha completa</a>${help ? `<a href="${esc(help)}" target="_blank" rel="noopener noreferrer">Preguntar por WhatsApp</a>` : ''}</p>
        </div>`;
      const track = body.querySelector('[data-gm-track]');
      bindTracks(body);
      if (scrollToColor && variant?.featured_image && track) {
        const idx = images.findIndex((src) => src.split('?')[0].endsWith(variant.featured_image.src.split('?')[0].split('/').pop()));
        if (idx > 0) track.scrollTo({ left: idx * track.clientWidth });
      }
    }

    /* Pocas unidades en la vista rápida: talla + color elegidos, o el total si aún no hay talla. */
    stockNote() {
      const { p, sizeIdx, colorIdx, color, size, stock } = this.qv;
      const max = Number(this.d.lowMax) || 0;
      if (!stock || !max) return '';
      let n = 0;
      for (const v of p.variants) {
        if (!v.available) continue;
        if (size && sizeIdx >= 0 && v.options[sizeIdx] !== size) continue;
        if (size && colorIdx >= 0 && v.options[colorIdx] !== color) continue;
        const q = stock.get(v.id);
        if (q == null) return '';
        n += q;
      }
      if (!n || n > max) return '';
      return n === 1 ? this.d.lastLabel : this.d.lowLabel.replace('[n]', n);
    }

    qvAdd(btn) {
      const variant = this.qvVariant();
      if (variant) this.addVariant(variant.id, btn, this.qv.p.id);
    }

    /* ---------- Viste hace poco ---------- */
    remember(item) {
      if (!item?.h) return;
      const list = readJSON(localStorage, RECENT_KEY, []).filter((x) => x && x.h !== item.h);
      writeJSON(localStorage, RECENT_KEY, [item, ...list].slice(0, 10));
      this.renderRecent();
    }

    rememberCard(card) {
      if (!card) return;
      const img = card.querySelector('.gmc__img');
      this.remember({ h: card.dataset.handle, t: card.querySelector('.gmc__name')?.textContent.trim(), p: Number(card.dataset.price), img: img?.currentSrc || img?.src });
    }

    renderRecent() {
      const box = this.querySelector('[data-gm-recent]');
      const track = box?.querySelector('[data-gm-rtrack]');
      if (!track) return;
      const list = readJSON(localStorage, RECENT_KEY, []).filter((x) => x && x.h && x.t);
      box.hidden = !list.length;
      track.replaceChildren(
        ...list.map((item) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'gmc__rcard';
          b.dataset.gmQvHandle = item.h;
          const media = document.createElement('span');
          media.className = 'gmc__rmedia';
          if (item.img) {
            const img = document.createElement('img');
            img.src = sized(item.img, 300);
            img.alt = '';
            img.loading = 'lazy';
            media.append(img);
          }
          const name = document.createElement('span');
          name.className = 'gmc__rname';
          name.textContent = item.t;
          const price = document.createElement('b');
          price.textContent = Number.isFinite(item.p) ? money(item.p, this.d.moneyFormat) : '';
          b.append(media, name, price);
          return b;
        })
      );
    }

    /* ---------- Compras recientes (pedidos reales guardados por Shopify Flow) ---------- */
    initSales() {
      const src = this.querySelector('[data-gm-sales]');
      const pop = this.querySelector('[data-gm-pop]');
      if (!src || !pop) return;
      let list = [];
      try {
        list = JSON.parse(src.textContent);
      } catch (e) {}
      const week = 7 * 24 * 60 * 60 * 1000;
      list = (Array.isArray(list) ? list : []).filter((s) => s && s.h && s.t && Date.now() - Date.parse(s.at) < week);
      const seen = readJSON(sessionStorage, 'gm-sales', { n: 0, off: false });
      if (!list.length || seen.off || seen.n >= 4) return;
      this.sales = { list, seen, pop };
      this.saleTimer = setTimeout(() => this.showSale(), 6000);
    }

    showSale() {
      const s = this.sales;
      if (!s || s.seen.off) return;
      if (this.querySelector('dialog[open]')) {
        this.saleTimer = setTimeout(() => this.showSale(), 4000);
        return;
      }
      const sale = s.list[s.seen.n % s.list.length];
      s.seen.n += 1;
      writeJSON(sessionStorage, 'gm-sales', s.seen);
      const mins = Math.max(1, Math.round((Date.now() - Date.parse(sale.at)) / 60000));
      const ago = mins < 60 ? `hace ${mins} min` : mins < 1440 ? `hace ${Math.round(mins / 60)} h` : `hace ${Math.round(mins / 1440)} ${Math.round(mins / 1440) === 1 ? 'día' : 'días'}`;
      s.pop.innerHTML = `
        <button type="button" class="gmc__pop-main" data-gm-qv-handle="${esc(sale.h)}">
          <span class="gmc__pop-media">${sale.img ? `<img src="${esc(sized(sale.img, 120))}" alt="" loading="lazy">` : ''}</span>
          <span class="gmc__pop-txt">Alguien${sale.c ? ` en ${esc(sale.c)}` : ''} compró<b>${esc(sale.t)}</b><small>${ago}</small></span>
        </button>
        <button type="button" class="gmc__pop-x" data-gm-pop-close aria-label="Cerrar aviso"><svg class="gm-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>`;
      s.pop.classList.add('is-show');
      this.saleTimer = setTimeout(() => {
        s.pop.classList.remove('is-show');
        if (s.seen.n < 4 && !s.seen.off) this.saleTimer = setTimeout(() => this.showSale(), 15000);
      }, 6000);
    }

    closeSale() {
      clearTimeout(this.saleTimer);
      if (!this.sales) return;
      this.sales.seen.off = true;
      writeJSON(sessionStorage, 'gm-sales', this.sales.seen);
      this.sales.pop.classList.remove('is-show');
    }

    /* ---------- Carrito ---------- */
    add(btn) {
      const card = btn.closest('[data-gm-card]');
      const variants = JSON.parse(card.querySelector('[data-gm-variants]').textContent);
      const size = btn.dataset.size || '';
      const color = card.dataset.color || '';
      const fits = (v) => v.a && (!size || v.s === size);
      const variant = variants.find((v) => fits(v) && (!color || v.c === color)) || variants.find(fits);
      if (!variant) return this.fail(this.d.errSoldout);
      this.addVariant(variant.id, btn, Number(card.dataset.id));
    }

    async addVariant(id, btn, productId) {
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: [{ id, quantity: 1 }] };
      if (drawer?.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = location.pathname;
      }
      const label = btn.innerHTML;
      let done = false;
      btn.disabled = true;
      btn.classList.add('is-loading');
      try {
        const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then((r) => r.json());
        if (res.status) return this.fail(res.description || res.message);

        if (drawer?.getSectionsToRender && res.sections) {
          drawer.getSectionsToRender().forEach((section) => {
            const target = document.getElementById(section.id);
            const source = new DOMParser().parseFromString(res.sections[section.id] || '', 'text/html').querySelector('#minicart-form');
            if (target && source) target.innerHTML = source.innerHTML;
          });
          drawer.cartAction?.();
          drawer.classList.remove('is-empty');
          if (this.d.openDrawer === 'true') drawer.open?.();
        }

        const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
        document.querySelectorAll('.cart-count').forEach((el) => {
          el.textContent = el.classList.contains('cart-count-drawer') ? `(${cart.item_count})` : cart.item_count > 100 ? '~' : cart.item_count;
        });
        document.querySelector('free-ship-progress-bar')?.init?.(cart.items_subtotal_price);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gm-coleccion', cartData: res });
        }
        this.dock(cart);
        this.upsell(cart, productId);

        done = true;
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        btn.textContent = btn.matches('.gmc__add, .gmc__qv-add') ? this.d.added : '✓';
        setTimeout(() => {
          btn.classList.remove('is-done');
          btn.innerHTML = label;
          btn.disabled = false;
        }, 1200);
      } catch (e) {
        this.fail(this.d.errGeneric);
      } finally {
        if (!done) {
          btn.classList.remove('is-loading');
          btn.innerHTML = label;
          btn.disabled = false;
        }
      }
    }

    dock(cart) {
      const dock = this.querySelector('[data-gm-dock]');
      if (!dock) return;
      const free = Number(this.d.free) || 0;
      const sub = cart.items_subtotal_price;
      const fmt = this.d.moneyFormat;
      let msg = this.d.shipDone;
      if (!cart.item_count) msg = this.d.shipEmpty.replace('[amount]', money(free, fmt));
      else if (sub < free) msg = this.d.shipLeft.replace('[amount]', money(free - sub, fmt));
      dock.querySelector('[data-gm-ship]').textContent = msg;
      const bar = dock.querySelector('[data-gm-bar]');
      if (bar && free) bar.style.width = `${Math.min(100, Math.round((sub / free) * 100))}%`;
      dock.querySelector('[data-gm-count]').textContent = cart.item_count ? ` · ${cart.item_count}` : '';
      dock.classList.toggle('is-free', cart.item_count > 0 && sub >= free);
      if (!reduce) {
        dock.classList.remove('is-pulse');
        void dock.offsetWidth;
        dock.classList.add('is-pulse');
      }
    }

    /* Completa tu envío gratis: sugiere una prenda relacionada que alcance el monto que falta. */
    async upsell(cart, productId) {
      const box = this.querySelector('[data-gm-up]');
      const free = Number(this.d.free) || 0;
      const missing = free - cart.items_subtotal_price;
      if (!box) return;
      if (!free || missing <= 0 || !productId) {
        box.hidden = true;
        return;
      }
      try {
        const res = await fetch(`${ROUTES}recommendations/products.json?product_id=${productId}&limit=10&intent=related`, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const inCart = new Set(cart.items.map((i) => i.product_id));
        const pool = (await res.json()).products.filter((p) => p.available && !inCart.has(p.id));
        const pick = pool.filter((p) => p.price >= missing).sort((a, b) => a.price - b.price)[0] || pool.sort((a, b) => b.price - a.price)[0];
        if (!pick) {
          box.hidden = true;
          return;
        }
        const fmt = this.d.moneyFormat;
        const single = pick.variants.filter((v) => v.available).length === 1 && pick.variants.length === 1;
        box.innerHTML = `
          <span class="gmc__up-media">${pick.featured_image ? `<img src="${esc(sized(pick.featured_image, 200))}" alt="" loading="lazy">` : ''}</span>
          <span class="gmc__up-txt"><small>Completa tu envío gratis</small><b>${esc(pick.title)}</b> · ${esc(money(pick.price, fmt))}</span>
          ${single
            ? `<button type="button" class="gm-btn gm-btn--line" data-gm-variant="${pick.variants[0].id}" data-gm-product="${pick.id}">${esc(this.d.addLabel)}</button>`
            : `<button type="button" class="gm-btn gm-btn--line" data-gm-qv-handle="${esc(pick.handle)}">Ver tallas</button>`}`;
        box.hidden = false;
      } catch (e) {
        console.warn('[gm-coleccion] sugerencia de envío gratis:', e.message);
        box.hidden = true;
      }
    }
  }

  customElements.define('gm-coleccion', GmColeccion);
  reveal();
  document.addEventListener('shopify:section:load', (e) => reveal(e.target));
})();
